/** Ársor a szolgáltatások oldalhoz — pricing-config alapján. */
export function formatServicePrice(section, config) {
  const billing = section?.billing || "none";
  const key = section?.addon_key;
  if (billing === "base") {
    const up = config?.listing_upload;
    const daily = config?.listing_daily;
    if (up != null && daily != null) {
      return `${up} kr feladás · ${daily} kr / nap fenntartás`;
    }
    return "Kredit alapú feladás és napi fenntartás";
  }
  if (billing === "daily_extra" && key === "detailed_stats") {
    const d = config?.detailed_stats_daily;
    return d != null ? `+${d} kr / nap, ha bekapcsolva` : "Extra napi kredit, ha aktív";
  }
  if (billing === "one_time" && key) {
    const v = config?.addons_one_time?.[key];
    return v != null ? `${v} kredit, egyszeri` : "Egyszeri kredit";
  }
  if (billing === "weekly" && key) {
    const v = config?.addons_weekly?.[key];
    return v != null ? `${v} kredit / hét` : "Heti kredit";
  }
  return null;
}
